///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request = abcsetup.replenishment_request || {};
abcsetup.replenishment_request.common = abcsetup.replenishment_request.common || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.replenishment_request.common = {
    lookupTimeout: null,

    column_map : [
        'ndc',
    ],

    /**
     * Bind any CRUD fields
     */
    bindFields: function() {

        abcsetup.replenishment_request.common.request_id = abcsetup.replenishment_request.workflow.workflow_task ? abcsetup.replenishment_request.workflow.workflow_task.entity_id : null;

        // Lookup ABC Item info and add supply issue item
        $('#app_models_replenishment_request_request_information_request_information_ndc, #app_models_replenishment_request_request_information_request_information_sap_num').on('keydown change', function(event) {
            var field = $(this);
            var sap_num = field.val().length == 8 ? true : false;

            clearTimeout(abcsetup.replenishment_request.common.lookupTimeout);

            // Clear out gcn field
            $('#app_models_replenishment_request_request_information_request_information_gcn').val('');

            // Enter key was pressed
            if (event.keyCode == 13) {
                event.preventDefault();
                abcsetup.replenishment_request.common._lookUpABCItem(field, false, sap_num);
                return false;
            }

            abcsetup.replenishment_request.common.lookupTimeout = setTimeout(function() {
                abcsetup.replenishment_request.common._lookUpABCItem(field, false, sap_num);
            }, event.type == 'change' ? 0 : 2000);

            if (abcsetup.replenishment_request.workflow.workflow_task
                && abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_ro_team_review') {
                $('#item-info').hide();
                $('#item-found').show();
            }
        });

        // Lookup of single ABC Item info and add an alternate item
            $('#alternate-item-ndc').on('keydown change', function(event) {
                var field = $(this);
                clearTimeout(abcsetup.replenishment_request.common.lookupTimeout);

                // Enter key was pressed
                if (event.keyCode == 13) {
                    event.preventDefault();
                    var ndcs = field.val().replace(/(\d{11})(?!$)/g, "$1,").split(',');
                    $('#alternate-item-ndc').val('');
                    abcsetup.replenishment_request.common._lookUpABCItems(ndcs, abcsetup.replenishment_request.common.request_id);
                    return false;
                }

                abcsetup.replenishment_request.common.lookupTimeout = setTimeout(function() {
                    var ndcs = field.val().replace(/(\d{11})(?!$)/g, "$1,").split(',');
                    $('#alternate-item-ndc').val('');
                    abcsetup.replenishment_request.common._lookUpABCItems(ndcs, abcsetup.replenishment_request.common.request_id);
                }, event.type == 'change' ? 0 : 2000);
            });

        // Lookup of multiple ABC Items from paste event
        $(document).on("paste", "#alternate-item-ndc", function (event) {
            clearTimeout(abcsetup.replenishment_request.common.lookupTimeout);
            var field = $(this);
            abcsetup.replenishment_request.common.lookupTimeout = setTimeout(function() {
            if (field.val()) {
                    var ndcs = field.val().replace(/(\d{11})(?!$)/g, "$1,").split(',');
                    $('#alternate-item-ndc').val('');
                    abcsetup.replenishment_request.common._lookUpABCItems(ndcs, abcsetup.replenishment_request.common.request_id);
                }
            }, event.type == 'change' ? 0 : 100);

        });

        // Remove alternate item, cannot target element directly because it is dynamically added
        $('body').on('click', '.remove-alternate-item', function(event) {
            if (confirm('Are you sure you want to remove this item?')) {
                $(this).closest('li').remove();
                $('.tooltip').remove();
            }
        });

        // Validate if at least one alternate item has been added
        $('form').on('submit', function(e) {
            if ($('ul#sortable li').is(":visible") && $('ul#sortable li').length == 0 && $('#no_items_check').is(':checked') == false) {
                e.preventDefault();
                abcsetup.alerts.show('No Alternate Items Selected', 'You must add at least one alternate item to continue.');
                return;
            }
        });

        // Items are being imported from an excel document
        $(document).on("change", "#import_replenishment_items_file", function () {
            $("#ndc_import").prop('disabled', false);
        });

        // Remove all alternate items from sortable list
        $(document).on("click", "#btn-clear-items", function () {
            if (abcsetup.alerts.confirm('Clear All Items', 'Are you sure you want to remove all the items from the list?', function(resp) {
                if (resp) {
                    $("#sortable").empty();
                }
            }));
        });

        // Items are being imported from an excel document
        $(document).on("click", "#ndc_import", function () {
            abcsetup.excel.readFile($("#import_replenishment_items_file")[0], function(data) {
                // var rows = abcsetup.excel.toArray(data, abcsetup.replenishment_request.common.column_map);
                var ndcs = data[0];
                ndcs.shift();

                abcsetup.replenishment_request.common._lookUpABCItems(ndcs, abcsetup.replenishment_request.common.request_id);
            }, true);

            $("#import_replenishment_items_file").val('').trigger('change');
        });

        // Prevent scrolling on number inputs
        $('form').on('focus', 'input[type=number]', function (e) {
            $(this).on('wheel.disableScroll', function (e) {
                e.preventDefault()
            })
        });

        $('form').on('blur', 'input[type=number]', function (e) {
            $(this).off('wheel.disableScroll')
        });

        $(document).on('click', '#alternate_ndc_toggle', function() {
            if ($(this).is(':checked')) {
                $('#new_ndc').removeAttr('disabled');
                $('#new_ndc').attr('required', true);
                $('#alternate_ndc_required_star').removeClass('d-none');
                $('input[type="radio"]').attr('disabled', true);
            } else {
                $('#new_ndc').attr('disabled', true);
                $('#new_ndc').removeAttr('required');
                $('#new_ndc').val(null);
                $('#new-item-found').hide();
                $('#alternate_ndc_required_star').addClass('d-none');
                $('input[type="radio"]').removeAttr('disabled');
            }
        });

        $(document).on('change', '#app_models_replenishment_request_esi_esi_able_to_order', function() {
            if ($(this).find(':selected').attr('data-value') == 'dropdown_additional_ndc_option') {
                $('.dropdown_additional_ndc_field').removeClass('d-none');
            } else {
                $('.dropdown_additional_ndc_field').addClass('d-none');
            }
        });

        $('#new_ndc').on('change', function(e) {
            if ($('#alternate_ndc_toggle').is(':checked') && $(this).val() != null && $(this).val() != '' && $(this).val() !== undefined) {
                $('#new-item-found').hide();
                abcsetup.replenishment_request.common._AdditionalNDC(abcsetup.replenishment_request.common.request_id, $(this).val());
            }
        });
    },

    bindFormElems: function () {
        // Validate if at least one alternate item has been added
        $(document).on("click", ":submit", function(e) {
            // We dont want to run these checks on save or reject!
            if (($(this).val() == 'approve' || $(this).val() == 'submit')
                && abcsetup.replenishment_request.workflow.workflow_task == undefined
                && $('#sortable li').length == 0) {
                        e.preventDefault();
                        abcsetup.alerts.show('No Alternate Items Selected', 'You must select an alternate item to continue.');
                        return;
            }
        });
    },

    /**
     *  Search ABC Item by Sap Num
     *
     * @param {*} field
     */
    _lookUpABCItem: function(field, alternate_item = false, sap_num = null, newNDC = null) {
        abcsetup.blockUI(true);

        // Let's only hit the API if the NDC is 11 characters long
        if ($(field).val().length == 11 || $(field).val().length == 8) {
            axios.post('/api/replenishment_operations/getABCItem', { value: field.val(), sap_num: sap_num }).then(response => {
                field.removeClass('is-valid');

                if (alternate_item == false) {
                    $('#item-found').hide();
                    $('#item-not-found').hide();
                } else {
                    $('#alternate-item-not-found').hide();
                }

                if (response.data.abc_item) {
                    if (!alternate_item) {
                        if (newNDC == null) {
                            $('#sap_num_lookup').html(response.data.abc_item.sap_num);
                            $('#sap_num').val(response.data.abc_item.sap_num);
                            $('#item_desc_lookup').html(response.data.abc_item.item_desc);
                            $('#mat_status_lookup').html(response.data.abc_item.mat_status);
                            $('#sap_supplier_num_lookup').html(response.data.abc_item.vendor_id);
                            $('#sap_supplier_name_lookup').html(response.data.abc_item.vendor_name);
                        } else {
                            $('#new_sap_num_lookup').html(response.data.abc_item.sap_num);
                            $('#new_sap_num').val(response.data.abc_item.sap_num);
                            $('#new_item_desc_lookup').html(response.data.abc_item.item_desc);
                            $('#new_mat_status_lookup').html(response.data.abc_item.mat_status);
                            $('#new_sap_supplier_num_lookup').html(response.data.abc_item.vendor_id);
                            $('#new_sap_supplier_name_lookup').html(response.data.abc_item.vendor_name);

                            $('#new_sap_num').val(response.data.abc_item.sap_num);
                            $('#new-item-found').show();
                        }

                        $('#item-found').show();

                        if (response.data.fdb_item) {
                            $('#app_models_replenishment_request_request_information_request_information_gcn').val(response.data.fdb_item.gcn);
                        }
                    } else {
                        $('#alternate-item-ndc').val('');
                        $("#sortable").append('<li class="ui-state-default list-group-item">' +
                            '<div class="row">' +
                                // '<input type="hidden" id="alternate-item-order" name="alternate_item_order">' +
                                '<input type="hidden" id="alternate-item-sap-num" name="alternate_item_sap_num['+ response.data.sap_num +']" value="'+ response.data.sap_num +'">' +
                                // '<div class="col align-self-center order-column">' +
                                //     '<span class="font-weight-bold">1</span>' +
                                // '</div>' +
                                '<div class="col-11">' +
                                    '<span class="font-weight-bold">'+ response.data.item_desc +' ('+ response.data.ndc +')</span><br>' +
                                    '<span class="vendor-info">'+ response.data.vendor_name +' ('+ response.data.vendor_id +')</span>' +
                                '</div>' +
                                '<div class="col-1">' +
                                    '<button type="button" id="remove-alternate-item" class="btn btn-danger btn-sm mt-2 remove-alternate-item" title="Remove Item"><i class="fas fa-trash-alt"></i></button>' +
                                '</div>' +
                            '</div>' +
                        '</li>');
                    }
                } else {
                    if (!alternate_item) {
                        $('#item-found').hide();
                        $('#item-not-found').show();
                    } else {
                        $('#alternate-item-not-found').show();
                    }
                }
            });
        }

        abcsetup.unblockUI();
    },

    /**
     *  Search ABC Item by Sap Num
     *
     * @param {*} field
     */
    _lookUpABCItems: function(ndcs, request_id = null) {
        abcsetup.blockUI(true);
        axios
            .post('/api/replenishment_operations/getABCItems', {
                ndcs: ndcs,
                request_id: request_id
            }).then(response => {
                let data = response.data;

                if (data.matches) {
                    $.each(data.matches, function(index, value ) {
                        let hasTAA = value.trade_agreement == 'X' ? 'YES' : 'NO';
                        let showTAA = ! ['esi_buyer', 'esi_supervisor', 'dha_reviewer'].includes(abcsetup.userRole.class);
                        let divisionVal = value.division == null ? 'N/A' : value.division;

                        if (value.sap_num !== undefined && $('input[name="alternate_item_sap_num['+ value.sap_num +']"]').length == 0) {
                            $("#sortable").append(`
                                <li class="ui-state-default list-group-item">
                                    <div class="row">
                                        <input type="hidden" id="alternate-item-sap-num" name="alternate_item_sap_num[${value.sap_num}]" value="${value.sap_num}">
                                        <div class="col-11">
                                            <span class="font-weight-bold">${value.item_desc} - (${value.ndc}) ${showTAA ? `- TAA: (${hasTAA})` : ``}</span><br>
                                            <span>SAP # - (${value.sap_num}) - Division: ${divisionVal}</span><br />
                                            <span class="vendor-info">${value.vendor_name} (${value.vendor_id})</span>
                                        </div>
                                        <div class="col-1">
                                            <button type="button" id="remove-alternate-item" class="btn btn-danger btn-sm mt-2 remove-alternate-item" title="Remove Item">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            `);
                        }

                    });
            }

            var no_matches = $.map(response.data.no_matches, function(value, index){
                return [value];
            });

            if (response.data.duplicate_items) {
                var duplicate_items = $.map(response.data.duplicate_items, function(value, index){
                    return [value.ndc];
                });
            }

            if (no_matches.length > 0 || duplicate_items.length > 0) {
                abcsetup.alerts.show('Items could not be loaded', 'The following NDCs could not be loaded: ' + no_matches.join(', ') + (duplicate_items && duplicate_items.length ? '<br><br> Duplicate NDC(s) (Already submitted for this request): ' + duplicate_items.join(', ') : ''));

            } else if (response.data.no_matches.length == 0 && response.data.matches.length == 0 && response.data.duplicate_items.length == 0) {
                abcsetup.alerts.show('Items could not be loaded', 'The NDCs could not be loaded. Please double check the NDCs on the import file and try again');
            }

            $("#ndc_import").prop('disabled', true);
            abcsetup.unblockUI();
        });
    },

    _AdditionalNDC: function(key, ndc) {
        abcsetup.blockUI(true);

        axios.post('/api/replenishment_operations/duplicate_check', {
            'key': key,
            'ndc': ndc
        })
        .then(response => {
            let data = response.data;

            if (data && data.has_duplicate == true) {
                abcsetup.unblockUI();
                $('#new_ndc').val(null);
                abcsetup.alerts.show('Duplicate NDC Detected', `The following NDC could not be loaded: ${ndc}. <br><br> Duplicate Items (Already submitted for this request).`);
            } else {
                abcsetup.unblockUI();

                if (data.abc_item == null) {
                    $('#new_ndc').val(null);
                    abcsetup.alerts.show('No Item Found', `No item was found for the NDC: ${ndc}.`);
                }

                $('#new_sap_num_lookup').html(data.abc_item.sap_num);
                $('#new_sap_num').val(data.abc_item.sap_num);
                $('#new_item_desc_lookup').html(data.abc_item.item_desc);
                $('#new_mat_status_lookup').html(data.abc_item.mat_status);
                $('#new_sap_supplier_num_lookup').html(data.abc_item.vendor_id);
                $('#new_sap_supplier_name_lookup').html(data.abc_item.vendor_name);

                $('#new_sap_num').val(data.abc_item.sap_num);
                $('#new-item-found').show();

                if (data.fdb_item) {
                    $('#app_models_replenishment_request_request_information_request_information_gcn').val(response.data.fdb_item.gcn);
                }
            }
        })
        .catch(error => {
            abcsetup.unblockUI();
            console.error(error);
        });
    }
}